import React, { createContext, useEffect, useState } from "react";
import HisseDevranilmasi from "../jsx/pages/companies-law/HisseDevranilmasi";
import SirketlerHisseDevranilmasi from "../jsx/pages/companies-law/SirketlerHisseDevranilmasi";
import Vekaletname from "../jsx/pages/companies-law/Vekaletname";
import SirketlerVekaletname from "../jsx/pages/companies-law/SirketlerVekaletname";
import OrtaklikJointVenture from "../jsx/pages/companies-law/OrtaklikJointVenture";
import SirketlerOrtaklikJointVenture from "../jsx/pages/companies-law/SirketlerOrtaklikJointVenture";
import SirketAnaMukaveleleri from "../jsx/pages/companies-law/SirketAnaMukaveleleri";
import YurtdisiIstiraklarimizinDigerHukukiIslemleri from "../jsx/pages/companies-law/YurtdisiIstiraklarimizinDigerHukukiIslemleri";
import SirketlerYurtdisiIstiraklarimizinDigerHukukiIslemleri from "../jsx/pages/companies-law/SirketlerYurtdisiIstiraklarimizinDigerHukukiIslemleri";
import RekabetHukukuIzınBasvurusu from "../jsx/pages/companies-law/RekabetHukukuIzınBasvurusu";
import RekabetHukukuSorusturmalar from "../jsx/pages/companies-law/RekabetHukukuSorusturmalar";
import YurtdisiDavaVeIhtilaflarinKoordinasyonu from "../jsx/pages/companies-law/YurtdisiDavaVeIhtilaflarinKoordinasyonu";
import DueDiligenceKoordinasyonu from "../jsx/pages/companies-law/DueDiligenceKoordinasyonu";
import SirketlerDueDiligenceKoordinasyonu from "../jsx/pages/companies-law/SirketlerDueDiligenceKoordinasyonu";
import Mutalaa from "../jsx/pages/companies-law/Mutalaa";
import IlmuhaberVeHisseSenedineIliskinYkKararlari from "../jsx/pages/companies-law/IlmuhaberVeHisseSenedineIliskinYkKararlari";
import Toplanti from "../jsx/pages/companies-law/Toplanti";
import SirketlerToplanti from "../jsx/pages/companies-law/SirketlerToplanti";
import SirketlerHukukuEgitim from "../jsx/pages/companies-law/Egitim";
import SirketlerHukukuEgitim1 from "../jsx/pages/companies-law/SirketlerEgitim";
import YeniDavaAcilmasi from "../jsx/pages/lawsuit-claims/YeniDavaAcilmasi";
import IcraTakibi from "../jsx/pages/lawsuit-claims/IcraTakibi";
import HacizIhbarnameleri from "../jsx/pages/lawsuit-claims/HacizIhbarnameleri";
import BasinHukuku from "../jsx/pages/lawsuit-claims/BasinHukuku";
import DavaIcraHukukuMutalaa from "../jsx/pages/lawsuit-claims/DavaIcraHukukuMutalaa";
import SavcilikIslemlerininTakipEdilmesi from "../jsx/pages/lawsuit-claims/SavcilikIslemlerininTakipEdilmesi";
import IhtarnameHazirlanmasi from "../jsx/pages/lawsuit-claims/IhtarnameHazirlanmasi";
import MahkemelerdenGelenYazilarinCevaplandirilmasi from "../jsx/pages/lawsuit-claims/MahkemelerdenGelenYazilarinCevaplandirilmasi";
import DavaIcraHukukuRaporlamalar from "../jsx/pages/lawsuit-claims/DavaIcraHukukuRaporlamalar";
import SirketlerDavaIcraHukukuRaporlamalar from "../jsx/pages/lawsuit-claims/SirketlerDavaIcraHukukuRaporlamalar";
import IsHukukuFesihSurecleri from "../jsx/pages/lawsuit-claims/IsHukukuFesihSurecleri";
import TicaretIsHukukuFesihSurecleri from "../jsx/pages/companies-law/TicaretIsHukukuFesihSurecleri";
import SirketlerTicaretIsHukukuFesihSurecleri from "../jsx/pages/companies-law/SirketlerTicaretIsHukukuFesihSurecleri";
import YurtdisiDavaVeIhtilaflarinKoordinasyonuDava from "../jsx/pages/lawsuit-claims/YurtdisiDavaVeIhtilaflarinKoordinasyonu";
import YurtdisiDavaVeIhtilaflarinKoordinasyonuDavaHarici from "../jsx/pages/lawsuit-claims/YurtdisiDavaVeIhtilaflarinKoordinasyonuHarici";
import Toplanti1 from "../jsx/pages/lawsuit-claims/Toplanti";
import SirketIciEgitimVerilmesi from "../jsx/pages/lawsuit-claims/SirketIciEgitimVerilmesi";
import Sozlesme from "../jsx/pages/contract-law/Sozlesme";
import SirketlerSozlesme from "../jsx/pages/contract-law/SirketlerSozlesme";
import SozlesmelerleIlgiliSoruVeUyusmazliklar from "../jsx/pages/contract-law/SozlesmelerleIlgiliSoruVeUyusmazliklar";
import SirketlerSozlesmelerleIlgiliSoruVeUyusmazliklar from "../jsx/pages/contract-law/SirketlerSozlesmelerleIlgiliSoruVeUyusmazliklar";
import Toplanti2 from "../jsx/pages/contract-law/Toplanti";
import SozlesmeHukukuEgitim from "../jsx/pages/contract-law/Egitim";
import FMHAleyheDavaAcilmasi from "../jsx/pages/intellectual-property-law/FMHAleyheDavaAcilmasi";
import FMHIliskinDavaAcilmasi from "../jsx/pages/intellectual-property-law/FMHIliskinDavaAcilmasi";
import MarkaPatentIslemleri from "../jsx/pages/intellectual-property-law/MarkaPatentIslemleri";
import IhtarnameDuzenlenmesi from "../jsx/pages/intellectual-property-law/IhtarnameDuzenlenmesi";
import SirketlerIhtarnameDuzenlenmesi from "../jsx/pages/intellectual-property-law/SirketlerIhtarnameDuzenlenmesi";
import FMHIliskinRaporlamalar from "../jsx/pages/intellectual-property-law/FMHIliskinRaporlamalar";
import FMHRaporlamalar from "../jsx/pages/intellectual-property-law/FMHRaporlamalar";
import SinaiMulkiyetHaklarinaIliskinSozlesmeHazirlanmasi from "../jsx/pages/intellectual-property-law/SinaiMulkiyetHaklarinaIliskinSozlesmeHazirlanmasi";
import ReklamSenaryosu from "../jsx/pages/intellectual-property-law/ReklamSenaryosu";
import ReklamDiger from "../jsx/pages/intellectual-property-law/ReklamDiger";
import BilisimVeInternetHukuku from "../jsx/pages/intellectual-property-law/BilisimVeInternetHukuku";
import FikriMulkiyetHukukunaIliskinMutalaa from "../jsx/pages/intellectual-property-law/FikriMulkiyetHukukunaIliskinMutalaa";
import Toplanti3 from "../jsx/pages/intellectual-property-law/Toplanti";
import FikriMulkiyetEgitim from "../jsx/pages/intellectual-property-law/Egitim";
import ResmiKurumlarYazisma from "../jsx/pages/general-law/ResmiKurumlarYazisma";
import HukukiMutalaa from "../jsx/pages/general-law/HukukiMutalaa";
import SPKMevzuati from "../jsx/pages/general-law/SPKMevzuati";
import HalkaArzSurecKoordinasyonu from "../jsx/pages/general-law/HalkaArzSurecKoordinasyonu";
import HukukiArastirma from "../jsx/pages/general-law/HukukiArastirma";
import GenelHukuk from "../jsx/pages/general-law/GenelHukuk";
import GHIhtarname from "../jsx/pages/general-law/Ihtarname";
import Toplanti4 from "../jsx/pages/general-law/Toplanti";
import HalkaAcikSirketIslemleri from "../jsx/pages/general-law/HalkaAcikSirketIslemleri";
import ResmiMerciDenetimleriBasvuru from "../jsx/pages/general-law/ResmiMerciDenetimleriBasvuru";
import SirketYonetmelikInceleme from "../jsx/pages/general-law/SirketYonetmelikInceleme";
import GenelHukukEgitim from "../jsx/pages/general-law/Egitim";
import BakanliktanResmiYanıt from "../jsx/pages/regulation/BakanliktanResmiYanıt";
import KanunYonetmelikTebligler from "../jsx/pages/regulation/KanunYonetmelikTebligler";
import UluslararasiRegulasyonlar from "../jsx/pages/regulation/UluslararasiRegulasyonlar";
import ReklamIcerikKontrolu from "../jsx/pages/regulation/ReklamIcerikKontrolu";
import CevreKanunu from "../jsx/pages/regulation/CevreKanunu";
import RegulasyonDiger from "../jsx/pages/regulation/RegulasyonDiger";
import YasalDenetimler from "../jsx/pages/regulation/YasalDenetimler";
import RegulasyonToplanti from "../jsx/pages/regulation/Toplanti";
import RegulasyonEgitim from "../jsx/pages/regulation/Egitim";
import GlobalHukukIsleriBaskanindanGorus from "../jsx/pages/presidential/GlobalHukukIsleriBaskanindanGorus";
import BaskanlikToplanti from "../jsx/pages/presidential/Toplanti";
import Sozlesmeler from "../jsx/pages/archive-management/Sozlesmeler";
import Vekaletnameler from "../jsx/pages/archive-management/Vekaletnameler";
import Ihtarnameler from "../jsx/pages/archive-management/Ihtarnameler";
import IsAkdiFesihleri from "../jsx/pages/archive-management/IsAkdiFesihleri";
import Users from "../jsx/pages/role/Users";
import UserRole from "../jsx/pages/role/User-Role";
import UserDepartment from "../jsx/pages/role/User-Department";
import Departments from "../jsx/pages/role/Departments";
import GroupCompanies from "../jsx/pages/role/GroupCompanies";
import Groups from "../jsx/pages/role/Groups";
import Roles from "../jsx/pages/role/Roles";
import RoleAuth from "../jsx/pages/role/Role-Auth";
import DemandTypes from "../jsx/pages/settings/DemandTypes";
import DocumentTypes from "../jsx/pages/settings/DocumentTypes";
import DemandStates from "../jsx/pages/settings/DemandStates";
import DocumentStates from "../jsx/pages/settings/DocumentStates";
import MailMessages from "../jsx/pages/settings/MailMessages";
import InfoBanksCategories from "../jsx/pages/settings/InfoBanksCategories";
import InfoBanksSubCategories from "../jsx/pages/settings/InfoBanksSubCategories";
import AboutGhib from "../jsx/pages/settings/AboutGhib";
import Announcement from "../jsx/pages/settings/Announcement";
import Dashboard from "../jsx/pages/home/Dashboard";
import PendingDemands from "../jsx/pages/home/PendingDemands";
import ContinuingDemands from "../jsx/pages/home/ContinuingDemands";
import DirectedDemands from "../jsx/pages/home/DirectedDemands";
import AllDemands from "../jsx/pages/home/AllDemands";
import Completed from "../jsx/pages/home/Completed";
import Rejected from "../jsx/pages/home/Rejected";
import NewDemands from "../jsx/pages/home/NewDemands";
import Assigned from "../jsx/pages/home/Assigned";
import AnnouncementDetails from "../jsx/pages/home/AnnouncementDetails";
import { useTranslation } from "react-i18next";
import DavaIcraSavcilikSikayetleri from "../jsx/pages/archive-management/DavaIcraSavcilikSikayetleri";
import OtherReports from "../jsx/pages/reports/OtherReports";
import request from "../jsx/services/request";
import AleyhimizeAcilanDavaninTakibi from "../jsx/pages/lawsuit-claims/AleyhimizeAcilanDavaninTakibi";
import SinaiHaklaraIliskinBeyanlar from "../jsx/pages/intellectual-property-law/SinaiHaklaraIliskinBeyanlar";
import KisiselVerilerIleIlgiliSurecler from "../jsx/pages/general-law/KisiselVerilerIleIlgiliSurecler";
import DemandDocType from "../jsx/pages/settings/DemandDocType";
import EditExistingRecords from "../jsx/pages/edit-existing-records/EditExistingRecords";
import TIOMutalaa   from "../jsx/pages/turkiye-istirakleri-ofisi/TIOMutalaa";
import TIOSozlesmeHazirlanmasi from "../jsx/pages/turkiye-istirakleri-ofisi/TIOSozlesmeHazirlanmasi";
import TIOIhtarname from "../jsx/pages/turkiye-istirakleri-ofisi/TIOIhtarname";
import TIOSozlesmelerleIlgiliSoruVeUyusmazliklar from "../jsx/pages/turkiye-istirakleri-ofisi/TIOSozlesmelerleIlgiliSoruVeUyusmazliklar";
import TIOVekaletnameHazirlanmasi from "../jsx/pages/turkiye-istirakleri-ofisi/TIOVekaletnameHazirlanmasi";
import TIOYeniDavaAcilmasi from "../jsx/pages/turkiye-istirakleri-ofisi/TIOYeniDavaAcilmasi";
import TIOAleyhimizeAcilanDavaninTakibi from "../jsx/pages/turkiye-istirakleri-ofisi/TIOAleyhimizeAcilanDavaninTakibi";
import TIOSavcilikSikayetleri from "../jsx/pages/turkiye-istirakleri-ofisi/TIOSavcilikSikayetleri";
import TIOIcraTakibi from "../jsx/pages/turkiye-istirakleri-ofisi/TIOIcraTakibi";
import TIOHacizIhbarnameleri from "../jsx/pages/turkiye-istirakleri-ofisi/TIOHacizIhbarnameleri";
import TIOMahkemelerdenGelenYazilarinCevaplandirilmasi from "../jsx/pages/turkiye-istirakleri-ofisi/TIOMahkemelerdenGelenYazilarinCevaplandirilmasi";
import TIOBasinHukuku from "../jsx/pages/turkiye-istirakleri-ofisi/TIOBasinHukuku";
import TIORaporlamalar from "../jsx/pages/turkiye-istirakleri-ofisi/TIORaporlamalar";
import TIOSirketIciEgitimVerilmesi from "../jsx/pages/lawsuit-claims/TIOSirketIciEgitimVerilmesi";
import GHIsHukuku from "../jsx/pages/lawsuit-claims/GHIsHukuku";
import MutalaaIlgiliKonular from "../jsx/pages/general-law/MutalaaIlgiliKonular";
import SirketlerMutalaaIlgiliKonular from "../jsx/pages/general-law/SirketlerMutalaaIlgiliKonular";
import { Redirect, useHistory } from "react-router-dom";
import IsYogunlugu from "../jsx/pages/reports/IsYogunlugu";
import AnnoucmentList from "../jsx/pages/settings/AnnoucmentList";
import TicaretSavcilikSikayetleri from "../jsx/pages/companies-law/TicaretSavcilikSikayetleri";
import TicaretToplanti from "../jsx/pages/companies-law/TicaretToplanti";
import TicaretEgitim from "../jsx/pages/companies-law/TicaretEgitim";
import TicaretSozlesmeHazirlanmasi from "../jsx/pages/companies-law/TicaretSozlesmeHazirlanmasi";
import SVekaletname from "../jsx/pages/companies-law/SVekaletname";
import SRaporlar from "../jsx/pages/companies-law/SRaporlar";
import SMutalaa from "../jsx/pages/companies-law/SMutalaa";
import SIhtarname from "../jsx/pages/companies-law/SIhtarname";
import FMHSozlesmelerleIlgiliSoruVeUyusmazliklar from "../jsx/pages/intellectual-property-law/FMHSozlesmelerleIlgiliSoruVeUyusmazliklar";
import FMHSozlesme from "../jsx/pages/intellectual-property-law/Sozlesme";
import CommonPage from "../jsx/pages/common/Page";

export const ThemeContext = createContext();

const ThemeContextProvider = (props) => {
  const [spinner, setSpinner] = useState(true);
  const [notificationTabStatus, setNotificationTabStatus] = useState(false);
  const [notification, setNotification] = useState([]);
  const [refreshNotification, setRefreshNotification] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [navigationHader, setNavigationHader] = useState("color_1");
  const [direction, setDirection] = useState({ value: "ltr", label: "LTR" });
  const [haderColor, setHaderColor] = useState("color_1");
  const [sidebarColor, setSidebarColor] = useState("color_1");
  const [iconHover, setIconHover] = useState(false);
  const [menuToggle, setMenuToggle] = useState(false);
  const [menus, setMenus] = useState([]);
  const [surecler, setSurecler] = useState([]);
  const [restriction, setRestriction] = useState(false);
  const [isDisAvukat, setIsDisAvukat] = useState(false);
  const [isGhibBaskani,setIsGhibBaskani] = useState(false);
  const [IsMasrafCheck, setIsMasrafCheck] = useState(false);

  const [sideBarStyle, setSideBarStyle] = useState({
    value: "full",
    label: "Full",
  });
  const [sidebarposition, setSidebarposition] = useState({
    value: "fixed",
    label: "Fixed",
  });
  const [headerposition, setHeaderposition] = useState({
    value: "fixed",
    label: "Fixed",
  });
  const [sidebarLayout, setSidebarLayout] = useState({
    value: "vertical",
    label: "Vertical",
  });
  const [background, setBackground] = useState({
    value: "light",
    label: "Light",
  });
  const [containerPosition_, setcontainerPosition_] = useState({
    value: "wide-boxed",
    label: "Wide Boxed",
  });
  const body = document.querySelector("body");
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const { t, i18n } = useTranslation();
  let resizeWindow = () => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);
    window.innerWidth >= 768 && window.innerWidth < 1280
      ? body.setAttribute("data-sidebar-style", "mini")
      : window.innerWidth <= 768
        ? body.setAttribute("data-sidebar-style", "overlay")
        : body.setAttribute("data-sidebar-style", "full");
  };

  const routes = [
    /// Şirketler Hukuku
    {
      url: "m-&-a-hisse-alım-satım-işlemleri",
      component: HisseDevranilmasi,
      title: t("sidebar.maHisseAlimSatimIslemleri"),
    },
    {
      url: "vekaletname-onayları",
      component: Vekaletname,
      title: t("sidebar.vekaletnameOlaylari"),
    },
    {
      url: "ortaklik-jv-kuruluşu-işlemleri",
      component: OrtaklikJointVenture,
      title: t("sidebar.ortaklikJv"),
    },
    {
      url: "esas-sözleşme-genel-kurul-kararları",
      component: SirketAnaMukaveleleri,
      title: t("sidebar.esasSözlesmeGenelKurulKararlari"),
    },
    {
      url: "yurtdışı-iştiraklerin-diğer-hukuki-işlemleri",
      component: YurtdisiIstiraklarimizinDigerHukukiIslemleri,
      title: t("sidebar.yurtdisiIstiraklerinDigerHukukiIslemleri"),
    },
    {
      url: "rekabet-hukuku-izin-başvurusu-ve-diğer-işlemler",
      component: RekabetHukukuIzınBasvurusu,
      title: t("sidebar.rekabetHukukuIzinBasvurusu"),
    },
    {
      url: "rekabet-hukuku-soruşturmalar",
      component: RekabetHukukuSorusturmalar,
      title: t("sidebar.rekabetHukukuSorusturmalar"),
    },
    {
      url: "yurtdışı-dava-ve-ihtilafların-takibi",
      component: YurtdisiDavaVeIhtilaflarinKoordinasyonu,
      title: t("sidebar.yurtDisiDavaveIhtilaflarinTakibi"),
    },
    {
      url: "ticaret-is-hukuku-fesih-surecleri",
      component: TicaretIsHukukuFesihSurecleri,
      title: t("sidebar.ishukukusurec"),
    },
    {
      url: "t_savcilik_sikayetleri",
      component: TicaretSavcilikSikayetleri,
      title: t("sidebar.tsavciliksikayetleri"),
    },
    {
      url: "t_toplanti",
      component: TicaretToplanti,
      title: t("sidebar.ttoplanti"),
    },
    {
      url: "t_egitim",
      component: TicaretEgitim,
      title: t("sidebar.tegitim"),
    },
    {
      url: "t_sozlesme_hazirlanmasi",
      component: TicaretSozlesmeHazirlanmasi,
      title: t("sidebar.tsozlesmehazirlanmasi"),
    },
    {
      url: "due-diligence-işlemleri",
      component: DueDiligenceKoordinasyonu,
      title: t("sidebar.dueDiligenceIslemleri"),
    },
    {
      url: "şirketler-hukukuna-ilişkin-görüş-talepleri",
      component: Mutalaa,
      title: t("sidebar.sirketlerHukukunaIliskinGorusTalepleri"),
    },
    {
      url: "yönetim-kurulu-kararları-ve-ilgili-evrakları",
      component: IlmuhaberVeHisseSenedineIliskinYkKararlari,
      title: t("sidebar.yonetimKuruluKararlariveIlgiliEvraklar"),
    },
    {
      url: "şirketler-toplantı",
      component: Toplanti,
      title: t("pageTitleofDemandCreate.sirketlerHukukuToplanti"),
    },
    {
      url: "şirketler-hukuku-eğitim",
      component: SirketlerHukukuEgitim,
      title: t("pageTitleofDemandCreate.sirketlerHukukuEgitim"),
    },
    {
      url: "s_vekaletname",
      component: SVekaletname,
      title: t("sidebar.svekaletname"),
    },
    {
      url: "s-ihtarname",
      component: SIhtarname,
      title: t("sidebar.sihtarname"),
    },
    {
      url: "s_raporlamalar",
      component: SRaporlar,
      title: t("sidebar.sraporlamalar"),
    },
    {
      url: "s_mutalaa",
      component: SMutalaa,
      title: t("sidebar.smutalaa"),
    },
    {
      url: "şirket-hukuk-mutaala",
      component: MutalaaIlgiliKonular,
      title: t("sidebar.sirketlerMutaala"),
    },

    ///Dava / İcra Hukuku
    {
      url: "dava-yeni-talep",
      component: YeniDavaAcilmasi,
      title: t("sidebar.davaYeniTalep"),
    },
    {
      url: "aleyhimize-açılan-davanın-takibi",
      component: AleyhimizeAcilanDavaninTakibi,
      title: t("sidebar.aleyhimiziAcilenDavaTakibi"),
    },
    {
      url: "icra-takibi-yeni-talep",
      component: IcraTakibi,
      title: t("sidebar.icraTalibiYeniTalep"),
    },
    {
      url: "haciz-ihbarnameleri-maaş-haciz-yazılarına-cevap",
      component: HacizIhbarnameleri,
      title: t("sidebar.hacizIhbarnameleriveMaasHacizYazilarinaCevap"),
    },
    {
      url: "basın-hukuku-tekzip",
      component: BasinHukuku,
      title: t("sidebar.basipHukukuTekzip"),
    },
    {
      url: "dava-icra-hukuku-mütalaa-ve-diğer",
      component: DavaIcraHukukuMutalaa,
    },
    {
      url: "savcılık",
      component: SavcilikIslemlerininTakipEdilmesi,
      title: t("sidebar.savcilikLeheAleyhe"),
    },
    {
      url: "ihtarname-hazırlanması",
      component: IhtarnameHazirlanmasi,
      title: t("sidebar.ihtarnameHazirlanmasi"),
    },
    {
      url: "mahkemelerden-gelen-yazılara-cevap",
      component: MahkemelerdenGelenYazilarinCevaplandirilmasi,
      title: t("sidebar.mahkemelerdenGelenYazilaraCevap"),
    },
    {
      url: "dava-icra-hukuku-raporlamalar",
      component: DavaIcraHukukuRaporlamalar,
      title: t("sidebar.davaIcraHukukuRaporlamalar"),
    },
    {
      url: "fmh-raporlamalar",
      component: FMHRaporlamalar,
      title: t("sidebar.fmhRaporlamalar"),
    },
    {
      url: "iş-hukuku-fesih-süreçleri",
      component: IsHukukuFesihSurecleri,
      title: t("sidebar.isHukukuFesihSurecleri"),
    },
    {
      url: "dava-icra-toplantı",
      component: Toplanti1,
      title: t("pageTitleofDemandCreate.davaIcraToplanti"),
    },
    {
      url: "dava-yurtdışı-dava-ve-ihtilafların-takibi",
      component: YurtdisiDavaVeIhtilaflarinKoordinasyonuDava,
      title: t("sidebar.yurtDisiDavaveIhtilaflarinTakibi"),
    },
    {
      url: "dava-yurtdışı-dava-ve-ihtilafların-takibi-harici",
      component: YurtdisiDavaVeIhtilaflarinKoordinasyonuDavaHarici,
      title: t("sidebar.yurtDisiDavaveIhtilaflarinTakibiHarici"),
    },
    {
      url: "dava-icra-eğitim",
      component: SirketIciEgitimVerilmesi,
      title: t("pageTitleofDemandCreate.davaIcraEgitim"),
    },

    ///Sözleşmeler Hukuku
    { url: "sözleşme", component: Sozlesme, title: t("sidebar.sözlesme") },
    {
      url: "sözleşmelerle-ilgili-soru-ve-uyuşmazlıklar",
      component: SozlesmelerleIlgiliSoruVeUyusmazliklar,
      title: t("sidebar.sözlesmelerleIlgiliSoruveUyusmazliklar"),
    },
    {
      url: "sözleşmeler-toplantı",
      component: Toplanti2,
      title: t("pageTitleofDemandCreate.sözlesmelerHukukuToplanti"),
    },
    {
      url: "sözleşmeler-hukuku-eğitim",
      component: SozlesmeHukukuEgitim,
      title: t("pageTitleofDemandCreate.sözlesmelerHukukuEgitim"),
    },

    ///Fikri Mülkiyet Hukuku
    {
      url: "yeni-dava",
      component: FMHIliskinDavaAcilmasi,
      title: t("sidebar.yeniDava"),
    },
    {
      url: "fmh-aleyhe-dava",
      component: FMHAleyheDavaAcilmasi,
      title: t("sidebar.fmhAleyheDava"),
    },
    // {url: "fmh-ilişkin-aleyhe-açılmış-davanın-takibi", component: FMHIliskinAleyheAcilmisDavaTakibi},
    {
      url: "marka-patent-endüstriyel-tasarım-işlemleri",
      component: MarkaPatentIslemleri,
      title: t("sidebar.markaPatentEndüstriyelTasarim"),
    },
    {
      url: "ihtarname-hazırlanması-ihtarnameye-cevap",
      component: IhtarnameDuzenlenmesi,
      title: t("sidebar.ihtarnameHazirlanmasiIhtarnameyeCevap"),
    },
    {
      url: "fmh-ilişkin-raporlamalar",
      component: FMHIliskinRaporlamalar,
      title: t("sidebar.fhmIliskinRaporlamalar"),
    },
    {
      url: "sınai-mülkiyet-haklarına-ilişkin-sözleşme-hazırlanması",
      component: SinaiMulkiyetHaklarinaIliskinSozlesmeHazirlanmasi,
      title: t("sidebar.sinaiMülkiyetHaklarinaIliskinSözlesme"),
    },
    {
      url: "reklam-senaryosu-ile-ilgili-talepler",
      component: ReklamSenaryosu,
      title: t("sidebar.reklamSenaryosuIleIlgiliTalepler"),
    },
    {
      url: "reklam-ile-ilgili-diğer-talepler",
      component: ReklamDiger,
      title: t("sidebar.reklamIleIlgiliDigerTalepler"),
    },
    {
      url: "bilişim-ve-internet-hukuku-ile-ilgili-talepler",
      component: BilisimVeInternetHukuku,
      title: t("sidebar.bilisimveInternetHukukuIleIlgiliTalepler"),
    },
    {
      url: "fikri-mülkiyet-hukukuna-ilişkin-hukuki-görüş-ve-diğer",
      component: FikriMulkiyetHukukunaIliskinMutalaa,
      title: t("sidebar.fikriMülkiyetHukukunaIliskinHukukiGorus"),
    },
    {
      url: "fikri-mülkiyet-toplantı",
      component: Toplanti3,
      title: t("pageTitleofDemandCreate.fmhToplanti"),
    },
    {
      url: "fikri-mülkiyet-eğitim",
      component: FikriMulkiyetEgitim,
      title: t("pageTitleofDemandCreate.fmhEgitim"),
    },
    // {url: "planet", component: Planet},
    {
      url: "sinai-haklara-ilişkin-beyanlar",
      component: SinaiHaklaraIliskinBeyanlar,
      title: t("sidebar.sinaiHaklaraIliskinBeyanlar"),
    },

    ///Genel Hukuk
    {
      url: "resmi-kurum-talep-itiraz-cevap-yazıları",
      component: ResmiKurumlarYazisma,
      title: t("sidebar.resmiKurumTalepItirazCevapYazilari"),
    },
    {
      url: "hukuki-görüş-talepleri",
      component: HukukiMutalaa,
      title: t("sidebar.hukukiGorusTalepleri"),
    },
    {
      url: "spk-mevzuatı-talepleri",
      component: SPKMevzuati,
      title: t("sidebar.spkMevzuatiTalepleri"),
    },
    {
      url: "halka-arz-işlemleri-tahvil-bono-ihracı",
      component: HalkaArzSurecKoordinasyonu,
      title: t("sidebar.halkaArzIslemleriTahvilBonoIhraci"),
    },
    {
      url: "mevzuat-inceleme-ve-görüş-talebi",
      component: HukukiArastirma,
      title: t("sidebar.mevzuatIncelemeVeGorusTalebi"),
    },
    // {url: "hukuki-sirküler-uygulama-akış-metni", component: HukukiSirkuler},
    {
      url: "kisisel-veriler-ile-ilgili-surecler",
      component: KisiselVerilerIleIlgiliSurecler,
      title: t("sidebar.kisiselVeriler"),
    },
    {
      url: "diğer-genel-hukuk-talepleri",
      component: GenelHukuk,
      title: t("sidebar.digerGenelHukukTalepleri"),
    },
    {
      url: "genel-hukuk-ihtarname",
      component: GHIhtarname,
      title: t("sidebar.genelHukukIhtarname"),
    },
    {
      url: "genel-hukuk-toplantı",
      component: Toplanti4,
      title: t("pageTitleofDemandCreate.genelHukukToplanti"),
    },
    {
      url: "gh-raporlamalar",
      component: HalkaAcikSirketIslemleri,
      title: t("sidebar.halkaAcikSirketIslemleri"),
    },
    {
      url: "gh-finans-hukuku",
      component: ResmiMerciDenetimleriBasvuru,
      title: t("sidebar.resmiMerciDenetimleri"),
    },
    {
      url: "şirket-yönetmelik-politika-prosedür-inceleme",
      component: SirketYonetmelikInceleme,
      title: t("sidebar.sirketYonetmelikPolitikaProsedürInceleme"),
    },
    {
      url: "genel-hukuk-eğitim",
      component: GenelHukukEgitim,
      title: t("pageTitleofDemandCreate.genelHukukEgitim"),
    },
    {
      url: "belge-onayi-glas-numarasi",
      component: GHIsHukuku,
      title: t("sidebar.isHukukundanDoganTalep"),
    },

    ///Regülasyon
    {
      url: "bakanlıktan-resmi-yanıt-talepleri",
      component: BakanliktanResmiYanıt,
      title: t("sidebar.bakanliktanResmiYanitTalepleri"),
    },
    {
      url: "kanun-yönetmelik-ve-tebliğler-hakkında-bilgilendirme",
      component: KanunYonetmelikTebligler,
      title: t("sidebar.kanunYonetmelikveTebliglerHakkindaBilgilendirme"),
    },
    {
      url: "uluslararası-regülasyonlar-ve-uygulamalar-konusunda-bilgi-talepleri",
      component: UluslararasiRegulasyonlar,
      title: t("sidebar.uluslararasiRegülasyonlarveUygulamalarKonusunda"),
    },
    {
      url: "reklam-ve-tanıtım-faaliyetlerinin-içeriklerinin-kontrolü-ve-değerlendirilmesi",
      component: ReklamIcerikKontrolu,
      title: t("sidebar.reklamveTanitimFaaliyetlerininIceriklerinin"),
    },
    {
      url: "çevre-kanunu-ile-ilgili-talepler",
      component: CevreKanunu,
      title: t("sidebar.cevreKanunuIleIlgiliTalepler"),
    },
    {
      url: "regülasyon-diğer",
      component: RegulasyonDiger,
      title: t("sidebar.regülasyonDiger"),
    },
    {
      url: "yasal-denetimler-ve-rakip-firma-şikayetleri",
      component: YasalDenetimler,
      title: t("sidebar.yasalDenetimlerveRakipFirmaSikayetleri"),
    },
    {
      url: "regülasyon-toplantı",
      component: RegulasyonToplanti,
      title: t("pageTitleofDemandCreate.regulasyonToplanti"),
    },
    {
      url: "regülasyon-eğitim",
      component: RegulasyonEgitim,
      title: t("pageTitleofDemandCreate.regulasyonEgitim"),
    },

    ///Başkanlık
    {
      url: "global-hukuk-işleri-başkanından-görüş-ve-destek-talepleri",
      component: GlobalHukukIsleriBaskanindanGorus,
      title: t("sidebar.globalHukukIsleriBaskanindanGorusveDestekTalepleri"),
    },
    {
      url: "başkanlık-toplantı",
      component: BaskanlikToplanti,
      title: t("pageTitleofDemandCreate.baskanlikToplanti"),
    },
    {
      url: "tio-mutalla-danisma",
      component: TIOMutalaa,
      title: t("sidebar.tioMutalaa"),
    },
    {
      url: "tio-ihtarname",
      component: TIOIhtarname,
      title: t("sidebar.tioIhtarname"),
    },
    {
      url: "tio-sozlesme-hazirlanmasi",
      component: TIOSozlesmeHazirlanmasi,
      title: t("sidebar.tioSozlesmeHazirlanmasi"),
    },
    {
      url: "tio-sozlesme-uyusmazliklar",
      component: TIOSozlesmelerleIlgiliSoruVeUyusmazliklar,
      title: t("sidebar.tioSozlesmeUyusmazliklar"),
    },
    {
      url: "tio-vekaletname",
      component: TIOVekaletnameHazirlanmasi,
      title: t("sidebar.tioVekaletname"),
    },
    {
      url: "tio-yeni-dava",
      component: TIOYeniDavaAcilmasi,
      title: t("sidebar.tioYenidava"),
    },
    {
      url: "tio-aleyhe-dava",
      component: TIOAleyhimizeAcilanDavaninTakibi,
      title: t("sidebar.tioAleyhedava"),
    },
    {
      url: "tio-savcilik",
      component: TIOSavcilikSikayetleri,
      title: t("sidebar.tioSavcilik"),
    },
    {
      url: "tio-icra-takip",
      component: TIOIcraTakibi,
      title: t("sidebar.tioIcratakip"),
    },
    {
      url: "tio-haciz-ihbar",
      component: TIOHacizIhbarnameleri,
      title: t("sidebar.tioHacizihbar"),
    },
    {
      url: "tio-mahkeme-cevap",
      component: TIOMahkemelerdenGelenYazilarinCevaplandirilmasi,
      title: t("sidebar.tioMahkemecevap"),
    },
    {
      url: "tio-basin-tekzip",
      component: TIOBasinHukuku,
      title: t("sidebar.tioBasintekzip"),
    },
    {
      url: "tio-raporlamalar",
      component: TIORaporlamalar,
      title: t("sidebar.tioRaporlamalar"),
    },
    {
      url: "tio-sirket-egitim",
      component: TIOSirketIciEgitimVerilmesi,
      title: t("sidebar.tioSirketegitim"),
    },
    ///Raporlar
    {
      url: "raporlar/diğer-raporlar",
      component: OtherReports,
      title: t("sidebar.digerRaporlamalar"),
    },
    {
      url: "raporlar/is-yogunlugu",
      component: IsYogunlugu,
      title: t("sidebar.IsYogunlugu"),
    },
    ///Bilgi Bankası
    ///arşiv ve yönetimi
    {
      url: "arşiv/sözleşmeler",
      component: Sozlesmeler,
      title: t("sidebar.sozlesmeler"),
    },
    {
      url: "arşiv/vekaletnameler",
      component: Vekaletnameler,
      title: t("sidebar.vekaletnameler"),
    },
    {
      url: "arşiv/dava-icra-savcılık-şikayetleri",
      component: DavaIcraSavcilikSikayetleri,
      title: t("sidebar.davaIcraSavcilikSikayetleri")
    },
    {
      url: "arşiv/ihtarnameler",
      component: Ihtarnameler,
      title: t("sidebar.ihtarnameler"),
    },
    {
      url: "arşiv/iş-akdi-fesihleri",
      component: IsAkdiFesihleri,
      title: t("sidebar.isAkdiFesihleri"),
    },
    ///Rol ve Yekilendirme
    { url: "kullanıcılar", component: Users, title: t("sidebar.kullanicilar") },
    { url: "kullanıcı-rol", component: UserRole },
    { url: "kullanıcı-departman", component: UserDepartment },
    {
      url: "departmanlar",
      component: Departments,
      title: t("sidebar.departmanlar"),
    },
    {
      url: "şirketler",
      component: GroupCompanies,
      title: t("sidebar.sirketler"),
    },
    {
      url: "şirket-grupları",
      component: Groups,
      title: t("sidebar.sirketGruplari"),
    },
    { url: "roller", component: Roles, title: t("sidebar.roller") },
    { url: "rol-yetki", component: RoleAuth },
    //Ayarlar
    {
      url: "talep-türleri",
      component: DemandTypes,
      title: t("sidebar.talepTürleri"),
    },
    {
      url: "dosya-türleri",
      component: DocumentTypes,
      title: t("sidebar.dosyaTürleri"),
    },
    {
      url: "talep-durumları",
      component: DemandStates,
      title: t("sidebar.talepDurumlari"),
    },
    {
      url: "dosya-durumları",
      component: DocumentStates,
      title: t("sidebar.dosyaDurumlari"),
    },
    {
      url: "mail-mesajları",
      component: MailMessages,
      title: t("sidebar.mailMesajlari"),
    },
    {
      url: "duyurular",
      component: AnnoucmentList,
      title: t("sidebar.duyuruListesi"),
    },
    {
      url: "bilgi-bankası-kategoriler",
      component: InfoBanksCategories,
      title: t("sidebar.bilgiBankasiKategorileri"),
    },
    { url: "bilgi-bankasi-kategori",
      component: InfoBanksSubCategories,
      title: t("sidebar.bilgiBankasiKategoriler")},
    {
      url: "GHİB-hakkında",
      component: AboutGhib,
      title: t("sidebar.ghibHakkinda"),
    },
    // {
    //   url: "duyurular",
    //   component: Announcement,
    //   title: t("sidebar.duyurular"),
    // },
    /// Deshborad
    { url: "", component: Dashboard, title: t("sidebar.anasayfa") },
    {
      url: "bekleyen-talepler",
      component: PendingDemands,
      title: t("anaSayfa.bekleyenTalepler"),
    },
    {
      url: "süreç-devam-ediyor",
      component: ContinuingDemands,
      title: t("anaSayfa.surecDevamEdenTalepler"),
    },
    {
      url: "süreci-devam-ediyor",
      component: ContinuingDemands,
      title: t("anaSayfa.sureciDevamEdenTalepler"),
    },
    {
      url: "yönlendirilmiş-talepler",
      component: DirectedDemands,
      title: t("anaSayfa.yeniTalepler"),
    },
    {
      url: "tüm-talepler",
      component: AllDemands,
      title: t("anaSayfa.tumTalepler"),
    },
    {
      url: "dosyalar",
      component: AllDemands,
      title: t("anaSayfa.dosyalar"),
    },
    {
      url: "tamamlananlar",
      component: Completed,
      title: t("anaSayfa.tamamlananlar"),
    },
    {
      url: "reddedilenler",
      component: Rejected,
      title: t("anaSayfa.reddedilenler"),
    },
    {
      url: "yeni-talepler",
      component: NewDemands,
      title: t("anaSayfa.yeniTalepler"),
    },
    { url: "atananlar", component: Assigned, title: t("anaSayfa.atananlar") },
    {
      url: "Duyuru/:duyuruId",
      component: AnnouncementDetails,
      title: t("anaSayfa.duyurular"),
    },
    {
      url: "evrak-tipi",
      component: DemandDocType,
      title: t("anaSayfa.evrakTipi"),
    },

    { url: "mevcut-kayıtları-güncelle", component: EditExistingRecords, title: t("sidebar.mevcutKayitlariDuzenle") },

    { url: "sirketler_hisse_devralinmasi", component: SirketlerHisseDevranilmasi, title: t("sidebar.sirketlerhissedevralinmasi") },
    { url: "sirketler_ortaklik", component: SirketlerOrtaklikJointVenture, title: t("sidebar.sirketlerortaklik") },
    { url: "sirketler_diligence", component: SirketlerDueDiligenceKoordinasyonu, title: t("sidebar.sirketlerdiligence") },
    { url: "sirketler_istirakler", component: SirketlerYurtdisiIstiraklarimizinDigerHukukiIslemleri, title: t("sidebar.sirketleristirakler") },
    { url: "sirketler_toplanti", component: SirketlerToplanti, title: t("sidebar.sirketlertoplanti") },
    { url: "sirketler_egitim", component: SirketlerHukukuEgitim1, title: t("sidebar.sirketleregitim") },
    { url: "sirketler_sozlesme_hazirlanmasi", component: SirketlerSozlesme, title: t("sidebar.sirketlersozlesmehazirlanmasi") },
    { url: "sirketler_sozlesme_uyumsuzluk", component: SirketlerSozlesmelerleIlgiliSoruVeUyusmazliklar, title: t("sidebar.sirketlersozlesmeuyumsuzluk") },
    { url: "sirketler_ihtarname", component: SirketlerIhtarnameDuzenlenmesi, title: t("sidebar.sihtarname") },
    { url: "sirketler_mutalaa", component: SirketlerMutalaaIlgiliKonular, title: t("sidebar.sirketlermutalaa") },
    { url: "sirketler_raporlamalar", component: SirketlerDavaIcraHukukuRaporlamalar, title: t("sidebar.sirketlerraporlamalar") },
    { url: "sirketler_vekaletname", component: SirketlerVekaletname, title: t("sidebar.sirketlervekaletname") },
    { url: "ticarethukuku_fesih", component: SirketlerTicaretIsHukukuFesihSurecleri, title: t("sidebar.ticarethukukufesih") },
    { url: "ugh_sozlesme_uyumsuzluk", component: FMHSozlesmelerleIlgiliSoruVeUyusmazliklar, title: t("sidebar.ughsozlesmeuyumsuzluk") },
    { url: "ugh_sozlesme_hazirlanmasi", component: FMHSozlesme, title: t("sidebar.ughsozlesmehazirlanmasi") },

    // Pladis
    { url: 'pladis-sozlesme-hazirlanmasi', render: () => <CommonPage type={1} tarafText="demandList.karsiTaraf" tahminiBedelTitle="demandCreate.sozlesmeBedeli" talepTurId={125} pageTitle={t('sidebar.pladissozlesmehazirlanmasi')} />, title: t('sidebar.pladissozlesmehazirlanmasi') },
    { url: 'pladis-sozlesme-uyusmazlik', render: () => <CommonPage type={2} talepTurId={126} pageTitle={t('sidebar.pladissozlesmeuyusmazliklar')} />, title: t('sidebar.pladissozlesmeuyusmazliklar') },
    { url: 'pladis-yeni-dava-acilmasi', render: () => <CommonPage type={5} talepTurId={127} tarafText="demandCreate.davaci" bedelTitle="demandCreate.muddeabih" pageTitle={t('sidebar.pladisyenidava')} />, title: t('sidebar.pladisyenidava') },
    { url: 'pladis-aleyhe-acilan-dava', render: () => <CommonPage type={5} talepTurId={128} bedelTitle="demandCreate.muddeabih" tarafText="demandCreate.davaci" pageTitle={t('sidebar.pladisaleyheacilan')} />, title: t('sidebar.pladisaleyheacilan') },
    { url: 'pladis-icra-takibi', render: () => <CommonPage type={5} talepTurId={129} tarafText="demandCreate.alacakli" davaliText="demandCreate.borclu" bedelTitle="demandCreate.takipTutari" pageTitle={t('sidebar.pladisicra')} />, title: t('sidebar.pladisicra') },
    { url: 'pladis-savcilik-sikayetleri', render: () => <CommonPage type={6} talepTurId={130} tarafText="demandCreate.musteki" davaliText="demandCreate.supheli" pageTitle={t('sidebar.pladissavcilik')} />, title: t('sidebar.pladissavcilik') },
    { url: 'pladis-mutalaa', render: () => <CommonPage type={2} talepTurId={131} pageTitle={t('sidebar.pladismutalaa')} />, title: t('sidebar.pladismutalaa') },
    { url: 'pladis-haciz-ihbarnameleri', render: () => <CommonPage type={2} talepTurId={132} tarafText="demandList.karsiTaraf" pageTitle={t('sidebar.pladishaciz')} />, title: t('sidebar.pladishaciz') },
    { url: 'pladis-mahkemelerden-gelen-yazilar', render: () => <CommonPage type={2} talepTurId={133} pageTitle={t('sidebar.pladismahkemelerdengelenyazilar')} />, title: t('sidebar.pladismahkemelerdengelenyazilar') },
    { url: 'pladis-is-hukuku-fesih', render: () => <CommonPage type={2} talepTurId={134} pageTitle={t('sidebar.pladisishukukufesih')} />, title: t('sidebar.pladisishukukufesih') },
    { url: 'pladis-raporlamalar', render: () => <CommonPage type={2} talepTurId={135} tarafText="demandCreate.ilgiliSirket" pageTitle={t('sidebar.pladisraporlamalar')} />, title: t('sidebar.pladisraporlamalar') },
    { url: 'pladis-egitim', render: () => <CommonPage type={2} talepTurId={136} pageTitle={t('sidebar.pladisegitim')} />, title: t('sidebar.pladisegitim') },
    { url: 'pladis-toplanti', render: () => <CommonPage type={2} talepTurId={137} pageTitle={t('sidebar.pladisttoplanti')} />, title: t('sidebar.pladisttoplanti') },
    { url: 'pladis-ihtarname-hazirlanmasi', render: () => <CommonPage type={2} talepTurId={150} tarafText="demandCreate.ihtarEdilen" pageTitle={t('sidebar.pladisihtarname')} />, title: t('sidebar.pladisihtarname') },
    { url: 'pladis-vekaletname-hazirlanmasi', render: () => <CommonPage type={2} talepTurId={151} tarafText="demandCreate.vekil" pageTitle={t('sidebar.pladisvekaletname')} />, title: t('sidebar.pladisvekaletname') },

    // Marka Patent
    { url: 'mp-marka-patent-endustriyel-tasarim', render: () => <CommonPage type={2} talepTurId={138} pageTitle={t('sidebar.mpmarkaPatentEndustriyelTasarim')} />, title: t('sidebar.mpmarkaPatentEndustriyelTasarim') },
    { url: 'mp-sinai-haklar-sozlesme-hazirlama', render: () => <CommonPage type={2} talepTurId={139} tarafText="demandList.karsiTaraf" tahminiBedelTitle="demandCreate.sozlesmeBedeli" pageTitle={t('sidebar.mpsinaiHaklarSozlesmeHazirlama')} />, title: t('sidebar.mpsinaiHaklarSozlesmeHazirlama') },
    { url: 'mp-yurtdisi-yeni-dava-acilmasi', render: () => <CommonPage type={5} tarafText="demandCreate.davaci" bedelTitle="demandCreate.muddeabih" talepTurId={140} pageTitle={t('sidebar.mpyurtdisiYeniDavaAcilmasi')} />, title: t('sidebar.mpyurtdisiYeniDavaAcilmasi') },
    { url: 'mp-yurtdisi-aleyhe-dava-takibi', render: () => <CommonPage type={5} talepTurId={141} bedelTitle="demandCreate.muddeabih" tarafText="demandCreate.davaci" pageTitle={t('sidebar.mpyurtdisiAleyheDavaTakibi')} />, title: t('sidebar.mpyurtdisiAleyheDavaTakibi') },
    { url: 'mp-yurtdisi-ihtarname-hazirlanmasi', render: () => <CommonPage type={2} talepTurId={142} tarafText="demandCreate.ihtarEdilen" pageTitle={t('sidebar.mpyurtdisiIhtarnameHazirlanmasi')} />, title: t('sidebar.mpyurtdisiIhtarnameHazirlanmasi') },
    { url: 'mp-egitim', render: () => <CommonPage type={2} talepTurId={143} pageTitle={t('sidebar.mpegitim')} />, title: t('sidebar.mpegitim') },
    { url: 'mp-toplanti', render: () => <CommonPage type={2} talepTurId={144} pageTitle={t('sidebar.mptoplanti')} />, title: t('sidebar.mptoplanti') },
    { url: 'mp-raporlamalar', render: () => <CommonPage type={2} talepTurId={145} tarafText="demandCreate.ilgiliSirket" pageTitle={t('sidebar.mpraporlamalar')} />, title: t('sidebar.mpraporlamalar') },
    { url: 'mp-mutalaa-danisma', render: () => <CommonPage type={2} talepTurId={146} pageTitle={t('sidebar.mpmutalaaDanisma')} />, title: t('sidebar.mpmutalaaDanisma') },

    { url: 'th-kamulastirma', render: () => <CommonPage type={5} tarafText="demandCreate.davaci" bedelTitle="demandCreate.muddeabih" talepTurId={148} pageTitle={t('sidebar.thkamulastirma')} />, title: t('sidebar.thkamulastirma') },
    { url: 'th-yurtdisi-dava', render: () => <CommonPage type={2} talepTurId={149} pageTitle={t('sidebar.thyurtdisidava')} />, title: t('sidebar.thyurtdisidava') },

  ];

  // layout
  const layoutOption = [
    { value: "vertical", label: "Vertical" },
    { value: "horizontal", label: "Horizontal" },
  ];
  const sideBarOption = [
    { value: "compact", label: "Compact" },
    { value: "full", label: "Full" },
    { value: "mini", label: "Mini" },
    { value: "modern", label: "Modern" },
    { value: "overlay", label: "Overlay" },
    { value: "icon-hover", label: "Icon-hover" },
  ];
  const backgroundOption = [
    { value: "light", label: "Light" },
    { value: "dark", label: "Dark" },
  ];
  const sidebarpositions = [
    { value: "fixed", label: "Fixed" },
    { value: "static", label: "Static" },
  ];
  const headerPositions = [
    { value: "fixed", label: "Fixed" },
    { value: "static", label: "Static" },
  ];
  const containerPosition = [
    { value: "wide-boxed", label: "Wide Boxed" },
    { value: "boxed", label: "Boxed" },
    { value: "wide", label: "Wide" },
  ];
  const colors = [
    "color_1",
    "color_2",
    "color_3",
    "color_4",
    "color_5",
    "color_6",
    "color_7",
    "color_8",
    "color_9",
    "color_10",
    "color_11",
    "color_12",
    "color_13",
    "color_14",
    "color_15",
  ];
  const directionPosition = [
    { value: "ltr", label: "LTR" },
    { value: "rtl", label: "RTL" },
  ];
  const fontFamily = [
    { value: "roboto", label: "Roboto" },
    { value: "poppins", label: "Poppins" },
    { value: "opensans", label: "Open Sans" },
    { value: "HelveticaNeue", label: "HelveticaNeue" },
  ];
  const changeSpinnerStatus = (value) => {
    setSpinner(value);
    /*body.setAttribute("data-nav-headerbg", name);*/
  };
  const changeNotificationTabStatus = (value) => {
    setNotificationTabStatus(value);
  };
  const getAnnouncements = () => {
    request({
      url: "duyurular/duyurularim",
      method: "POST",
      data: {
        body: {
          "sortOrder": "DESC", "pageIndex": 0, "pageSize": 100, "filters": []
        },
      },
    }).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setNotification(response.body.tableData);
        var count = 0;
        response.body.tableData.forEach(e => {
          if(e.okumusUserId == null) {
              count += 1
          }
        });
        setNotificationCount(count); 
      }
    });
  };
  const refreshNotificationHandle = (val) => {
    if (val) {
      getAnnouncements();
    }
  } 
  const changeNavigationHader = (name) => {
    setNavigationHader(name);
    body.setAttribute("data-nav-headerbg", name);
  };
  const chnageHaderColor = (name) => {
    setHaderColor(name);
    body.setAttribute("data-headerbg", name);
  };
  const chnageSidebarColor = (name) => {
    setSidebarColor(name);
    body.setAttribute("data-sibebarbg", name);
  };
  const changeSideBarPostion = (name) => {
    setSidebarposition(name);
    body.setAttribute("data-sidebar-position", name.value);
  };
  const changeDirectionLayout = (name) => {
    setDirection(name);
    body.setAttribute("direction", name.value);
    let html = document.querySelector("html");
    html.setAttribute("dir", name.value);
    html.className = name.value;
  };
  const changeSideBarLayout = (name) => {
    if (name.value === "horizontal") {
      if (sideBarStyle.value === "overlay") {
        setSidebarLayout(name);
        body.setAttribute("data-layout", name.value);
        setSideBarStyle({ value: "full", label: "Full" });
        body.setAttribute("data-sidebar-style", "full");
      } else {
        setSidebarLayout(name);
        body.setAttribute("data-layout", name.value);
      }
    } else {
      setSidebarLayout(name);
      body.setAttribute("data-layout", name.value);
    }
  };
  const changeSideBarStyle = (name) => {
    if (sidebarLayout.value === "horizontal") {
      if (name.value === "overlay") {
        alert("Sorry! Overlay is not possible in Horizontal layout.");
      } else {
        setSideBarStyle(name);
        setIconHover(name.value === "icon-hover" ? "_i-hover" : "");
        body.setAttribute("data-sidebar-style", name.value);
      }
    } else {
      setSideBarStyle(name);
      setIconHover(name.value === "icon-hover" ? "_i-hover" : "");
      body.setAttribute("data-sidebar-style", name.value);
    }
  };

  const changeHeaderPostion = (name) => {
    setHeaderposition(name);
    body.setAttribute("data-header-position", name.value);
  };

  const openMenuToggle = () => {
    sideBarStyle.value === "overly"
      ? setMenuToggle(true)
      : setMenuToggle(false);
  };

  const changeBackground = (name) => {
    body.setAttribute("data-theme-version", name.value);
    setBackground(name);
  };

  const changeContainerPosition = (name) => {
    setcontainerPosition_(name);
    body.setAttribute("data-container", name.value);
    name.value === "boxed" &&
      changeSideBarStyle({ value: "overlay", label: "Overlay" });
  };

  const getMenus = () => {
    request({
      url: "user/info",
      method: "GET",
    }).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setIsGhibBaskani(response.body.ghibBaskan);
        setIsMasrafCheck(response.body.masrafCheck);
        
        if (response.body.surecler) {
          for (var i = 0; i < response.body.surecler.length; i++) {
            surecler.push(response.body.surecler[i])
          }
          setSurecler(surecler);
        }

        if (response.body.anasayfaTipi === "TUM_TALEPLER") {
          setRestriction(true);
        }

        if(response.body.talepEkraniTipi === "DIS_AVUKAT_EKRANI") {
          setIsDisAvukat(true);
        }


        setMenus(response.body.menuTree.children);
      }
    });
  };

  useEffect(() => {
    body.setAttribute("data-typography", "poppins");
    body.setAttribute("data-theme-version", "light");
    body.setAttribute("data-layout", "vertical");
    body.setAttribute("data-nav-headerbg", "color_1");
    body.setAttribute("data-headerbg", "color_1");
    body.setAttribute("data-sidebar-style", "overlay");
    body.setAttribute("data-sibebarbg", "color_13");
    body.setAttribute("data-primary", "color_13");
    body.setAttribute("data-sidebar-position", "fixed");
    body.setAttribute("data-header-position", "fixed");
    body.setAttribute("data-container", "wide");
    body.setAttribute("direction", "ltr");

    i18n.on('languageChanged', (lng) => {
      getMenus();
    })
    getMenus();
    resizeWindow();
    getAnnouncements();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);

  }, ['should be called one time']);  

  return (
    <ThemeContext.Provider
      value={{
        isGhibBaskani,
        routes,
        menus,
        spinner,
        setSpinner,
        changeSpinnerStatus,
        notification,
        notificationCount,
        notificationTabStatus,
        changeNotificationTabStatus,
        refreshNotificationHandle,
        body,
        sideBarOption,
        layoutOption,
        backgroundOption,
        sidebarposition,
        headerPositions,
        containerPosition,
        directionPosition,
        fontFamily,
        navigationHader,
        changeNavigationHader,
        changeSideBarStyle,
        sideBarStyle,
        changeSideBarPostion,
        sidebarpositions,
        changeHeaderPostion,
        headerposition,
        changeSideBarLayout,
        sidebarLayout,
        changeDirectionLayout,
        changeContainerPosition,
        direction,
        colors,
        haderColor,
        chnageHaderColor,
        chnageSidebarColor,
        sidebarColor,
        iconHover,
        menuToggle,
        openMenuToggle,
        changeBackground,
        background,
        containerPosition_,
        restriction,
        surecler,
        isDisAvukat,
        showConfirmModal,
        IsMasrafCheck,
        userObj: props.user
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
